import { render } from "./users-list.vue?vue&type=template&id=5e53e83f&scoped=true"
import script from "./users-list.vue?vue&type=script&lang=js"
export * from "./users-list.vue?vue&type=script&lang=js"

import "./users-list.vue?vue&type=style&index=0&id=5e53e83f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e53e83f"]])

export default __exports__